import { getId } from "helpers/functions";
import {
  DELETE_SINGLE_HIRING,
  DELETE_SINGLE_HIRING_FAILURE,
  DELETE_SINGLE_HIRING_SUCCESS,
  GET_ALL_HIRING,
  GET_ALL_HIRING_SUCCESS,
  GET_SINGLE_HIRING,
  GET_SINGLE_HIRING_FAILURE,
  GET_SINGLE_HIRING_SUCCESS,
} from "./actionTypes";
import { GET_ALL_CONTACTUSS_FAILURE } from "store/contactUs/actionTypes";

const initialState = {
  hiring: [],
  loading: false,
  error: "",
  singleHiring: {},
};

const stores = (state = initialState, action) => {
  switch (action.type) {
    // get all hiring
    case GET_ALL_HIRING:
      state = {
        ...state,
        loading: true,
      };
      break;

    case GET_ALL_HIRING_SUCCESS:
      state = {
        ...state,
        loading: false,
        hiring: action.payload.hiringRequests,
      };
      break;

    case GET_ALL_CONTACTUSS_FAILURE:
      state = {
        ...state,
        error: action.payload,
        loading: false,
      };
      break;

    case GET_SINGLE_HIRING:
      state = { ...state, loading: true };

      break;

    case GET_SINGLE_HIRING_SUCCESS:
      state = {
        ...state,
        loading: false,
        singleHiring: action?.payload?.hiringRequest,
      };
      break;

    case GET_SINGLE_HIRING_FAILURE:
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;

    // delete contact
    case DELETE_SINGLE_HIRING:
      state = {
        ...state,
        loading: true,
      };

      break;

    case DELETE_SINGLE_HIRING_SUCCESS:
      const HiringAfterDeleteing = [
        ...state?.hiring?.filter((hiring) => getId(hiring) !== action.payload),
      ];

      state = {
        ...state,
        loading: false,
        hiring: HiringAfterDeleteing,
      };
      break;

    case DELETE_SINGLE_HIRING_FAILURE:
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default stores;
